/** A point in the canvas's global space (Pixi's `global`: the stage's coordinates). */
export interface CanvasPoint {
  x: number;
  y: number;
}

/** A title's tap on the canvas (decision 51): true takes the tap, so nothing else acts on it. */
export type CanvasTapTarget = (globalPoint: CanvasPoint) => boolean;

/**
 * Where a title adds its canvas tap targets (decision 51). The shell's tap surface covers the scene under the controls,
 * so a node in the scene never sees a tap: the surface offers each one to the targets, the latest added first, before
 * its own rule (the slam). `add` returns the removal.
 */
export interface CanvasTapTargets {
  add(target: CanvasTapTarget): () => void;
}

/** The shell's side of `CanvasTapTargets`: the list, and the offer the tap surface makes for each tap. */
export class CanvasTapRegistry implements CanvasTapTargets {
  private readonly targets: CanvasTapTarget[] = [];

  public add(target: CanvasTapTarget): () => void {
    this.targets.push(target);
    return () => {
      const index = this.targets.indexOf(target);
      if (index >= 0) this.targets.splice(index, 1);
    };
  }

  /** The tap to each target, the latest added first; true when one took it. */
  public offer(point: CanvasPoint): boolean {
    for (let i = this.targets.length - 1; i >= 0; i--) if (this.targets[i]!(point)) return true;
    return false;
  }
}
